import React, { useState } from "react";
import {
  motion,
  AnimatePresence,
} from "framer-motion";

const ServiceFaq = ({
  faqData = [],
  ctaBg,
  heading="",
  customClass = "",
}) => {

  const [activeIndex, setActiveIndex] =
    useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(
      activeIndex === index
        ? null
        : index
    );
  };

  // PREMIUM FADE
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // FAQ CARD
  const faqVariant = {
    hidden: {
      opacity: 0,
      y: 25,
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.08,
        duration: 0.65,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

  return (
    <>
      <section className="service-faq-section container">

        {/* LEFT */}

        <motion.div
          className="service-faq-left"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.15,
          }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.1,
              },
            },
          }}
        >

          {/* TOP */}

          <motion.div
            className="faq-top"
            variants={fadeUp}
          >

            <h2 className="section-heading">
             {heading || "Frequently Asked Questions" }
            </h2>

            <p className="section-text faq-desc">
              Stay informed with expert advice,
              local market updates, and practical
              step-by-step guidance designed to help
              you navigate your property journey
              with complete confidence.
            </p>

          </motion.div>

          {/* FAQ LIST */}

          <div className="service-faq-list">

            {faqData.map((item, index) => (

              <motion.div
                className={`faq-item ${
                  activeIndex === index
                    ? "active-faq"
                    : ""
                }`}
                key={index}
                custom={index}
                variants={faqVariant}
                whileHover={{
                  y: -3,
                }}
                transition={{
                  duration: 0.25,
                }}
              >

                {/* QUESTION */}

                <button
                  className="faq-question"
                  onClick={() =>
                    toggleFaq(index)
                  }
                >

                  <span>
                    {item.question}
                  </span>

                  <motion.div
                    className="faq-icon"
                    animate={{
                      rotate:
                        activeIndex === index
                          ? 180
                          : 0,
                    }}
                    transition={{
                      duration: 0.35,
                    }}
                  >
                    ⌄
                  </motion.div>

                </button>

                {/* ANSWER */}

                <AnimatePresence initial={false}>

                  {activeIndex === index && (

                    <motion.div
                      className="faq-answer show-answer"
                      initial={{
                        height: 0,
                        opacity: 0,
                      }}
                      animate={{
                        height: "auto",
                        opacity: 1,
                      }}
                      exit={{
                        height: 0,
                        opacity: 0,
                      }}
                      transition={{
                        duration: 0.4,
                        ease: "easeInOut",
                      }}
                      style={{
                        overflow: "hidden",
                      }}
                    >

                      <motion.p
                        className="section-text"
                        initial={{
                          opacity: 0,
                          y: 8,
                        }}
                        animate={{
                          opacity: 1,
                          y: 0,
                        }}
                        exit={{
                          opacity: 0,
                          y: -4,
                        }}
                        transition={{
                          duration: 0.3,
                        }}
                      >
                        {item.answer}
                      </motion.p>

                    </motion.div>

                  )}

                </AnimatePresence>

              </motion.div>

            ))}

          </div>

        </motion.div>

        {/* RIGHT CTA */}

        <motion.div
  className={`service-faq-cta ${customClass}`}
  initial={{
    opacity: 0,
    x: 50,
  }}
  whileInView={{
    opacity: 1,
    x: 0,
  }}
  transition={{
    duration: 1,
    ease: [0.22, 1, 0.36, 1],
  }}
  viewport={{
    once: true,
    amount: 0.2,
  }}
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(200,182,146,0.72),
        rgba(24,38,60,0.95)
      ),
      url(${ctaBg})
    `,
  }}
>

          <div className="service-faq-cta-content">

            <motion.h3
              className="card-heading"
              initial={{
                opacity: 0,
                y: 20,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.15,
                duration: 0.7,
              }}
              viewport={{
                once: true,
              }}
            >
              Ready for a smooth settlement?
            </motion.h3>

            <motion.p
              className="section-text"
              initial={{
                opacity: 0,
                y: 20,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.25,
                duration: 0.7,
              }}
              viewport={{
                once: true,
              }}
            >
              Let our experienced team handle
              every detail so you can move
              forward with confidence and
              complete peace of mind.
            </motion.p>

            <motion.div
              className="service-faq-btns"
              initial={{
                opacity: 0,
                y: 20,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.35,
                duration: 0.7,
              }}
              viewport={{
                once: true,
              }}
            >

              <motion.a
                href="/get-a-quote"
                className="primary-btn"
                whileHover={{
                  y: -3,
                  scale: 1.02,
                }}
                whileTap={{
                  scale: 0.97,
                }}
              >
                Get a Quote
              </motion.a>

              <motion.a
                href="/contact-us"
                className="secondary-btn"
                whileHover={{
                  y: -3,
                  scale: 1.02,
                }}
                whileTap={{
                  scale: 0.97,
                }}
              >
                Contact Us
              </motion.a>

            </motion.div>

          </div>

        </motion.div>

      </section>
    </>
  );
};

export default ServiceFaq;